import type { SchemaViewerFieldExpressionProps } from "./schema-viewer-field-expression.type";

import { useEffect } from "react";

import { useEvaluateExpressionField } from "@/modules/expression-field";
import { isNil } from "@/utilities/data";

export const useSchemaViewerFieldExpression = ({
  schema,
  form,
}: SchemaViewerFieldExpressionProps) => {
  const { result, error, unit } = useEvaluateExpressionField(schema, form);

  const model = schema.model;
  const value = !isNil(result) && unit ? `${result} ${unit}` : result;

  useEffect(() => {
    form.setFieldsValue({ [model]: value });
  }, [form, model, value]);

  return {
    value,
    error,
  };
};
